import { apiFetch } from './client';
import type { AdminBoardView, HousekeepingItem, HousekeepingItemBody, LoginEvent } from '$lib/types';

export interface LoginEventFilters {
  user_id?: string;
  status?: string;
  limit?: number;
  offset?: number;
}

function qs(filters: LoginEventFilters): string {
  const params = new URLSearchParams();
  for (const [key, value] of Object.entries(filters)) {
    if (value !== undefined && value !== '') params.set(key, String(value));
  }
  const s = params.toString();
  return s ? `?${s}` : '';
}

// adminLoginEventsApi — user management moved to /api/hr/users (see
// $lib/api/hr's hrUsersApi); board + housekeeping CRUD below are the other
// two surfaces still under /api/admin.
export const adminLoginEventsApi = {
  list: (filters: LoginEventFilters) => apiFetch<LoginEvent[]>(`/admin/login_events${qs(filters)}`)
};

// adminHousekeepingApi is the full CRUD view (active or not) behind Manage >
// Housekeeping's admin actions — hr gets a read-only view via
// $lib/api/board's housekeepingApi (active-only) instead.
export const adminHousekeepingApi = {
  list: () => apiFetch<HousekeepingItem[]>('/admin/housekeeping'),
  create: (body: HousekeepingItemBody) =>
    apiFetch<HousekeepingItem>('/admin/housekeeping', { method: 'POST', body: JSON.stringify(body) }),
  update: (id: number, body: HousekeepingItemBody) =>
    apiFetch<HousekeepingItem>(`/admin/housekeeping/${id}`, { method: 'PATCH', body: JSON.stringify(body) })
};

// adminBoardApi backs the admin-only read-only Board section on the
// employee detail page (GET /api/admin/users/:id/board) — 403s for hr.
export const adminBoardApi = {
  get: (userId: number) => apiFetch<AdminBoardView>(`/admin/users/${userId}/board`)
};
